import userApi, { sellerApi, riderApi, adminApi } from "./api";

class WalletService {
    /**
     * Helper to get the correct API instance based on role
     */
    getApi(role = "user") {
        if (role === "seller") return sellerApi;
        if (role === "rider") return riderApi;
        if (role === "admin") return adminApi;
        return userApi;
    }

    async getMyWallet(role = "user") {
        return await this.getApi(role).get("/api/v1/wallet/my-wallet");
    }

    async topupWallet(data, role = "user") {
        return await this.getApi(role).post("/api/v1/wallet/topup", data);
    }

    async confirmTopup(data, role = "user") {
        return await this.getApi(role).post("/api/v1/wallet/topup/confirm", data);
    }

    async topupWithSlip(formData, role = "user") {
        return await this.getApi(role).post("/api/v1/wallet/topup-slip", formData, {
            headers: { "Content-Type": "multipart/form-data" }
        });
    }

    async getPlatformPaymentInfo(role = "user") {
        return await this.getApi(role).get("/api/v1/wallet/payment-info");
    }

    async getTopUpQRCode(amount, role = "user") {
        return await this.getApi(role).get(`/api/v1/wallet/qrcode?amount=${amount}`);
    }

    async getTransactionChain(transactionId, role = "user") {
        if (role === "admin") {
            return await adminApi.get(`/api/v1/admin/commission/transaction/${transactionId}/chain`);
        }
        return await this.getApi(role).get(`/api/v1/commission-wallet/transaction/${transactionId}/chain`);
    }

    /**
     * ดึงข้อมูลธนาคารจาก profile แล้ว normalize เป็น { bankName, bankAccountNumber, bankAccountName, ownerName }
     */
    async fetchProfileBank(role = "user") {
        if (role === "seller") {
            const res = await sellerApi.get("/api/v1/auth/seller/profile");
            const s = res.data?.seller;
            return {
                bankName: s?.bank?.bankName || "",
                bankAccountNumber: s?.bank?.bankAccountNumber || "",
                bankAccountName: s?.bank?.bankAccountName || "",
                ownerName: `${s?.natId_firstName || ""} ${s?.natId_lastName || ""}`.trim() || s?.shopName || "",
            };
        }
        if (role === "rider") {
            const res = await riderApi.get("/api/v1/auth/rider/profile");
            const r = res.data?.data;
            return {
                bankName: r?.bank?.bankName || "",
                bankAccountNumber: r?.bank?.bankAccountNumber || "",
                bankAccountName: r?.bank?.bankAccountName || "",
                ownerName: `${r?.natId_firstName || ""} ${r?.natId_lastName || ""}`.trim(),
            };
        }
        // user — ไม่มี bank ใน schema ส่งกลับ empty
        const res = await userApi.get("/api/v1/users/profile");
        const u = res.data?.user;
        return {
            bankName: "",
            bankAccountNumber: "",
            bankAccountName: "",
            ownerName: `${u?.firstName || ""} ${u?.lastName || ""}`.trim(),
        };
    }

    async convertPointsToCash(points, role = "user") {
        return await this.getApi(role).post("/api/v1/commission-wallet/convert", { points });
    }

    async requestWithdrawal(data, role = "user") {
        return await this.getApi(role).post("/api/v1/withdrawal/request", data);
    }

    async getMyWithdrawals(role = "user") {
        return await this.getApi(role).get("/api/v1/withdrawal/my");
    }

    async listWithdrawals(status) {
        const q = status && status !== "all" ? `?status=${status}` : "";
        return await adminApi.get(`/api/v1/withdrawal/list${q}`);
    }

    async approveWithdrawal(id, data = {}) {
        return await adminApi.put(`/api/v1/withdrawal/${id}/approve`, data);
    }

    async rejectWithdrawal(id, rejectReason) {
        return await adminApi.put(`/api/v1/withdrawal/${id}/reject`, { rejectReason });
    }
}

export default new WalletService();
